export const variantPropMap = {
  filled: {
    btnClassName: 'language-select__button--filled'
  }
};
